import { OfferBase } from './bases/offer-base';
import { toApi as toApiBase } from './bases/offer-base';

export class CouponGeneric extends OfferBase {
  coupon_diffusion_type = 'QR';
  coupon_generic_code: string;
  coupon_rate: number;
  coupon_total_number: number;
  coupon_value: number;
  segments: any = [];
  total_consumers: number;

  constructor(payload: Object = {}) {
    super();

    Object.assign(this, payload);

    this.trimTimezoneFromDates();
  }
}

export function toApi(data) {
  data = toApiBase(data);

  return data;
}
